import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { patientAction } from '../../actions/constant';
import patientService from 'src/services/apiServices/patientServices';

const { FAILURE_UPLOAD_CSV_TEMPLATE, REQUEST_UPLOAD_CSV_TEMPLATE, SUCCESS_UPLOAD_CSV_TEMPLATE } =
  patientAction;

function* uploadCsvTemplate(payload: any): SagaReturnType<any> {
  try {
    // yield put({ type: LOADER_ON });
    const response = yield call(patientService.uploadCSVTemplate, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_UPLOAD_CSV_TEMPLATE, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_UPLOAD_CSV_TEMPLATE, payload: error });
  }
}

function* uploadCsvTemplateSaga() {
  yield takeEvery(REQUEST_UPLOAD_CSV_TEMPLATE, uploadCsvTemplate);
}

export default uploadCsvTemplateSaga;
